var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityRenewables(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -834.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Renewables",
    transform: "translate(2734.000000, 834.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9642386,15.1368946 C17.1437909,15.2798955 17.3031687,15.4488966 17.4121106,15.6608979 L17.4121106,15.6608979 L18.2453138,17.276908 L18.9816798,17.9579122 L18.9816798,29.9999875 C20.0953074,29.9999875 20.9991211,30.8959931 20.9991211,32 L20.9991211,32 L14.9467974,32 C14.9467974,30.8959931 15.8506111,29.9999875 16.9642386,29.9999875 L16.9642386,29.9999875 Z M20.6279119,5.86197757e-14 C22.0693736,0.489003056 22.916699,1.96601229 22.606013,3.44402153 L22.606013,3.44402153 L21.3985744,8.64405403 L20.4987956,10.0200626 C19.851197,11.0110688 19.945008,12.3060769 20.7267665,13.1960825 L20.7267665,13.1960825 L27,20.327127 C25.8520759,21.3191332 24.1372509,21.3081332 23.0014315,20.3031269 L23.0014315,20.3031269 L19.0623775,16.6661042 L18.3098719,15.206095 C17.7691977,14.1550885 16.591012,13.5870849 15.4229135,13.8140863 L15.4229135,13.8140863 L6.05694261,15.6340977 L6.02724911,15.456396 C5.83365222,14.0363981 6.68775614,12.6671992 8.07640128,12.2140763 L8.07640128,12.2140763 L13.2228939,10.6500666 L14.8751782,10.7340671 C16.0634511,10.7950675 17.1488345,10.0670629 17.5341658,8.95105594 L17.5341658,8.95105594 Z M17.9729592,11.0970694 C17.4161454,11.0970694 16.9642386,11.5450722 16.9642386,12.0970694 C16.9642386,12.6490791 17.4161454,13.0970819 17.9729592,13.0970819 C18.5307817,13.0970819 18.9816798,12.6490791 18.9816798,12.0970694 C18.9816798,11.5450722 18.5307817,11.0970694 17.9729592,11.0970694 Z",
    id: 69
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityRenewables);
export default __webpack_public_path__ + "static/media/transport-and-utility-renewables.b81ff90c.svg";
export { ForwardRef as ReactComponent };